import { useGetFreeAssessment } from "@/api/free-assessment/useGetFreeAssessment";
import LoadingScreen from "@/components/Loading";
import { saveAssessmentPaperId } from "@/lib/freeAssessment";
import AssessmentForm from "./_components/AssessmentForm";

function FreeAssessment() {
  const { data, isLoading } = useGetFreeAssessment({
    onSuccess: (data) => {
      saveAssessmentPaperId(data.data.id);
    },
  });

  if (!data || isLoading) {
    return <LoadingScreen />;
  }

  const categories = data.data.main_categories;

  return <AssessmentForm categories={categories} />;
}

export default FreeAssessment;
